import 'css-chunk:src/feature/check-fees/CheckFeesModal.module.scss';export default {
  "content": "CheckFeesModal_content",
  "autoFee": "CheckFeesModal_autoFee",
  "feeGrid": "CheckFeesModal_feeGrid",
  "divider": "CheckFeesModal_divider",
  "appliedValue": "CheckFeesModal_appliedValue"
};